<div class="card text-center">
  <div class="card-body d-flex flex-column">
    <h4 class="card-title text-primary text-center custom-tile-header">
      {{ 'local_listings.facebook_clicks' | translate}}
      <small>
        <helpPopover placement='top' html="{{ 'local_listings.facebook_clicks_tooltip' | translate }}"></helpPopover>
      </small>
    </h4>
    @if (chartData.hasData) {
      <h6 class="text-secondary">({{ graphSubtitle }})</h6>
    }
    <div *ngIf="chartData" class="row">
      <app-facebook-status [facebookStatus]="facebookStatus" [hasChartData]="chartData.hasData" [locationId]="locationId"></app-facebook-status>
      <div class="col-12">
        <div class="p-2 text-center text-md-left d-flex flex-column h-100">
          <canvas class="chart-canvas" baseChart
                  [data]="data"
                  [labels]="labels"
                  [options]="options"
                  [colors]="chartColors"
                  [type]="'line'"></canvas>
        </div>
      </div>
      <div class="col-12">
        <div><i class="fas fa-mouse-pointer"></i> {{ totalClicks }}</div>
        <div>{{ 'local_listings.facebook_clicks' | translate }}</div>
      </div>
    </div>
  </div>
</div>
